import { useQuery } from "react-query";
import { getActivePerformanceTerm } from "../../../faunadb/queries/performance";

export default function usePerformanceTerm(client) {
    return useQuery(["performance_term"], () => getActivePerformanceTerm(client), { refetchOnWindowFocus: false, refetchOnMount: false })
}